module.exports = __webpack_public_path__ + "img/23.d6be594a.png";